const padMonth = (value: string): string => {
  const val = parseInt(value.substring(0, 2));

  if (val > 1) {
    return "0" + val + " - " + value.substring(2);
  }

  return value;
};

const validateMonth = (value: string): string => {
  const val = parseInt(value.substring(0, 2));

  if (val > 12) {
    return "1 - " + value.substring(2);
  }

  return value;
};

export const formatExpirationValue = (value: string): string => {
  switch (value?.length) {
    case 1:
      return padMonth(value);
    case 2:
      return validateMonth(value);

    default:
      return value;
  }
};
